import {financeAPI} from "../../axios";

export const state = {
  deliveryUnits: [],
  isDeliveryUnitsLoading: false,
  isAvailableOEisLoading: false,
  isOfficeBudgetLoading: false,
  isAvailableAccountsLoading: false,
};
export const mutations = {
  setDeliveryUnits(state, deliveryUnits) {
    state.deliveryUnits = deliveryUnits;
  },
  setIsDeliveryUnitsLoading(state, isDeliveryUnitsLoading) {
    state.isDeliveryUnitsLoading = isDeliveryUnitsLoading;
  },
  setIsAvailableOEisLoading(state, isAvailableOEisLoading) {
    state.isAvailableOEisLoading = isAvailableOEisLoading;
  },
  setIsOfficeBudgetLoading(state, isOfficeBudgetLoading) {
    state.isOfficeBudgetLoading = isOfficeBudgetLoading;
  },
  setIsAvailableAccountsLoading(state, isAvailableAccountsLoading) {
    state.isAvailableAccountsLoading = isAvailableAccountsLoading;
  },
};
export const actions = {
  createFinanceTemplate(context, data) {
    return financeAPI.post("/FinanceTemplate/Create", data);
  },
  getTemplateByFundSource(context, data) {
    return financeAPI.get(`/FinanceTemplate/FundSource/${data}`);
  },
  getPreplanning(context, { fundSourceId, cycle }) {
    return financeAPI.get(`/FinanceTemplate/FundSource/${fundSourceId}/${cycle}`);
  },
  updateFinanceTemplate(context, { data, id }) {
    return financeAPI.put(`/FinanceTemplate/${id}`, data);
  },
  deleteFinanceTemplate(context, id) {
    return financeAPI.delete(`/FinanceTemplate/${id}`);
  },
  getAllPrexcListing(context, { financeTemplateId, outcomeId }) {
    return financeAPI.get(`/FinanceTemplate/Prexc/${financeTemplateId}/${outcomeId}`);
  },
  getTemplateExpenditures(context, { financeTemplateId, prexcId }) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/Prexc/${financeTemplateId}/${prexcId}`);
  },
  getAvailableAccounts(context, { financeTemplateId }) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/AvailableAccounts/${financeTemplateId}`);
  },
  getAvailableAccountsByDU(context, { financeTemplateId, duId }) {
    return financeAPI.get(`/FinanceTemplateBudgetItem/ObjectOfExpenditure/Available/${financeTemplateId}/${duId}`);
  },
  createMultipleTemplateExpenditures(context, data) {
    return financeAPI.post("/FinanceTemplateObjectOfExpenditure/Create/Multiple", data);
  },
  deleteObjectOfExpenditure(contex, id) {
    return financeAPI.delete(`/FinanceTemplateObjectOfExpenditure/${id}`);
  },
  getBudgetItemsByOE(context, data) {
    return financeAPI.get(`/FinanceTemplateBudgetItem/FinanceTemplateObjectOfExpenditure/${data}`);
  },
  getAvailableDeliveryUnits(context, data) {
    return financeAPI.get(`/FinanceTemplateBudgetItem/Available/DeliveryUnits/${data}`);
  },
  createMultipleBudgetItem(context, data) {
    return financeAPI.post("/FinanceTemplateBudgetItem/Create/Multiple", data);
  },
  deleteBudgetItem(context, data) {
    return financeAPI.delete(`/FinanceTemplateBudgetItem/${data}`);
  },
  updateTemplateBudgetItem(context, data) {
    return financeAPI.put(`/FinanceTemplateBudgetItem/${data.id}`, data);
  },
  getObjectExpenditurebyFinance(contex, financeTemplateId) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/FinanceTemplate/${financeTemplateId}`);
  },
  getFinanceExpenditureBalance(contex, financeTemplateObjectOfExpenditureId) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/Allocated/${financeTemplateObjectOfExpenditureId}`);
  },
  getPrexcTemplateBalance(context, { financeTemplateId, prexcId }) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/Prexc/Allocated/${financeTemplateId}/${prexcId}`);
  },
  sendTemplate(context, id) {
    return financeAPI.post(`/FinanceTemplate/Send/${id}`);
  },
  importTemplate(context, { financeTemplateId, fundSourceId, cycle, isActualDestination }) {
    return financeAPI.post(`/FinanceTemplate/Import/${financeTemplateId}/${fundSourceId}/${cycle}/${isActualDestination}`);
  },
  postPrePlanning(context, id) {
    return financeAPI.post(`/FinanceTemplate/Post/${id}`);
  },
  updateIsExclusive(context, { ids, isExclusive }) {
    return financeAPI.put(`/FinanceTemplateBudgetItem/Update/Multiple/Exclusive?value=${isExclusive}`, ids);
  },
  updateIsLock(context, { ids, isLock }) {
    return financeAPI.put(`/FinanceTemplateBudgetItem/Update/Multiple/Lock?value=${isLock}`, ids);
  },
  getSingleTemplate(context, id) {
    return financeAPI.get(`/FinanceTemplate/${id}`);
  },
  getAllDeliveryUnitsByTemplate(context, financeTemplateId) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/DeliveryUnits/${financeTemplateId}`);
  },
  getAvailabelFinanceTemplateExpenditures(context, { financeTemplateId, deliveryUnitId, prexcId }) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/DeliveryUnit/Available/${financeTemplateId}/${deliveryUnitId}/${prexcId}`);
  },
  getTemplateBudgetItemByDeliveryUnitAndTemplateId(context, { financeTemplateId, deliveryUnitId }) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/BudgetItems/${financeTemplateId}/${deliveryUnitId}`);
  },
  getDeliveryUnitFigures(context, { financeTemplateId, deliveryUnitId }) {
    return financeAPI.get(`/FinanceTemplateObjectOfExpenditure/Total/${financeTemplateId}/${deliveryUnitId}`);
  },
  getDeliveryUnitFunds(context, { deliveryUnitId, cycle }) {
    return financeAPI.get(`/FinanceTemplateBudgetItem/DeliveryUnit/Funds/${deliveryUnitId}/${cycle}`);
  },
  getBudgetItemByOPCR(context, data){
    return financeAPI.get(`/FinanceTemplateBudgetItem/PreOpcr/${data}`);
  }
};
